import { Td, Tr } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { rankingData } from '../../service/leaderboard';
import { UserProfile } from '../../service/social';

interface LeaderboardRowProps {
    rankData: rankingData;
    profile: UserProfile | undefined;
    isOddRow: boolean;
    activeUserId: string;
}

export const LeaderboardRow: React.FC<LeaderboardRowProps> = ({
    rankData,
    profile,
    isOddRow,
    activeUserId,
}) => {
    let className = '';
    if (activeUserId === profile?.id) {
        className = ' leaderboard-myrank';
    } else {
        className = 'leaderboard-row';
        if (isOddRow) {
            className += ' leaderboard-stripe';
        }
    }

    if (!profile) {
        return <></>;
    }

    return (
        <Tr className={className}>
            <Td>{rankData.rank}</Td>
            <Td>
                <Link to={`/user/${profile.id}`}>{profile.username}</Link>
            </Td>
            <Td>{rankData.score}</Td>
        </Tr>
    );
};
